import type { HolterZorgDomeinExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterZorgdomeinExaminationRequestSchemas';
import { holterDirectExaminationRequestInitialData } from '../holterDirectExaminationRequest/holterDirectExaminationRequestData';
import { holterExaminationRequestPatientAlternativeAddressInitialData } from '../utils/initialData';

export const holterZorgdomeinExaminationRequestInitialData: HolterZorgDomeinExaminationRequestData = {
    ...holterDirectExaminationRequestInitialData,
    ...holterExaminationRequestPatientAlternativeAddressInitialData,
    assets: [],
    patient: {
        emailAddress: null,
        homePhoneNumber: null,
        mobileNumber: null,
    },
};
